import { render, staticRenderFns } from "./reportPaxTotalsDest.vue?vue&type=template&id=334c9795&"
import script from "./reportPaxTotalsDest.vue?vue&type=script&lang=js&"
export * from "./reportPaxTotalsDest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports